import { createContext } from "react";
import {
  Plan,
  PendingInvoice,
  SubscriptionGetDetailedResponse,
  SubscriptionGetLiteResponse,
  SupportedAddon,
} from "@jugl-web/rest-api";
import { SelectedPlanInfo } from "@web-src/modules/cx/components/CompletePurchaseDialog/components/SummaryStep/types";
import { UpdateCardAlertResult } from "@web-src/modules/entities/providers/EntitySubscriptionProvider/components/UpdateCardAlert/types";

export type AddonLineItem = {
  addonName: string;
  quantity: number;
  subscriptionItemId: string;
  priceId: string;
  unitAmount: number;
};

export type EntitySubscription = {
  status: string;
  planName: string;
  planId: string;
  billingInterval: "month" | "year";
  currentPeriodEnd: string;
  currentPeriodStart: string;
  totalPrice: number;
  addonLineItems: Record<string, AddonLineItem>;
  raw: SubscriptionGetDetailedResponse;
};

export interface SubscriptionV2ContextValue {
  subscription: SubscriptionGetDetailedResponse | undefined;
  liteSubscription: SubscriptionGetLiteResponse | undefined;
  entitySubscription: EntitySubscription | undefined;
  plans: Plan[] | undefined;
  supportedAddons: SupportedAddon[] | undefined;
  currentPlan: Plan | undefined;
  currentPlanId: string | undefined;
  isFree: boolean;
  isMonthly: boolean;
  userCount: number;
  extraUserCount: number;
  seatUsage: number;
  pendingInvoices: PendingInvoice[];
  hasPaymentFailed: boolean;
  isSubscriptionCanceled: boolean;
  isSubscriptionPendingCancel: boolean;
  isLoading: boolean;
  defaultAgentKnowledge: number;
  refetchSubscription: () => void;
  cancelSubscription: () => void;
  reactivateCurrentPlan: () => void;
  openSubscriptionDrawer: (config?: {
    onSelectPlan?: (planInfo: SelectedPlanInfo) => void;
  }) => void;
  closeSubscriptionDrawer: () => void;
  openPurchaseDialog: (planInfo: SelectedPlanInfo) => void;
  closePurchaseDialog: () => void;
  updateCardDetails: () => Promise<UpdateCardAlertResult>;
  hasPaymentMethod: boolean;
  adjustSeats: () => void;
  upgradeSubscriptionPlan: (params: {
    planId: string;
    priceId: string;
    planName: string;
    onSuccess: () => void;
    onFailure?: (pendingInvoice?: PendingInvoice) => void;
  }) => Promise<void>;
  isChangePlanInProgress: boolean;
  isAddonPurchaseInProgress: boolean;
  isExtraCreditsDialogRequested: boolean;
  requestExtraCreditsDialog: () => void;
  clearExtraCreditsDialogRequest: () => void;
  topupCredits: (params: {
    amountInCents: number;
    onSuccess: () => void;
    onOpenInvoice: (invoiceUrl: string) => void;
  }) => Promise<void>;
  isTopupInProgress: boolean;
  maxRollOverCredits: number;
  planDefaultCredits: number;
}

export const SubscriptionV2Context =
  createContext<SubscriptionV2ContextValue | null>(null);
